import { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute, LayoutSplashScreen } from "../_metronic/layout";
import OverviewPages from "./modules/Overview/pages";
import UserManagementPages from "./modules/UserManagement/pages";
import ThemeManagementPages from "./modules/ThemeManagement/pages";
import Instruments from "./modules/Instrument/pages";
import PendingKYCPages from "./modules/PendingKyc/pages";
import { Permissions } from "./util/Permissions";
import ExchangeRateManagementPages from "./modules/ExchangeRateManagement/pages";
import OrderManagementPages from "./modules/OrderManagement/pages";
import TransactionManagement from "./modules/TransactionManagement/pages";
import PaymentManagement from "./modules/PaymentManagement/pages";
import HoldingManagement from "./modules/HoldingManagement/pages";
import CardManagement from "./modules/CardManagement/pages";
import SubscriptionManagement from "./modules/SubscriptionManagement/pages";
import GiftCardManagement from "./modules/GiftCardManagement/pages";
import SocialManagement from "./modules/SocialManagement/pages";
import PortfolioCreation from "./modules/PortfolioCreation/pages";
import ReportManagement from "./modules/ReportManagement/pages";
import MaintenanceFeeManagementPages from "./modules/MaintenanceFeeManagement/Pages";
import StalledTransaction from "./modules/StalledTransactions/pages";
import CampaignManagementPages from "./modules/CampaignManagement/pages";
import SecurityQuestionPages from "./modules/SecurityQuestionsManagement/pages";
import GemsPages from "./modules/Gems/pages";
import CommercialPaperManagementPages from "./modules/CommercialPaperManagement/pages";
import AiAssistant from "./modules/UserManagement/pages/selected-user/view-user/user-pages/ai/AiAssistant";
import TroveNextPages from "./modules/TroveNext/pages";
import CorporateAccountsPages from "./modules/CorporateAccounts/pages";





export default function BasePage() {
    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>

                {/* Redirect from root URL to /overview.  */}
                <Redirect exact from="/login" to="/overview" />

                <Redirect exact from="/" to="/overview" />


                <Redirect exact from="/2fa-otp" to="/overview" />

                <ContentRoute path="/overview" component={OverviewPages} />

                <ContentRoute path="/pending-kyc" permission={Permissions.PENDING_KYC} component={PendingKYCPages} />
                <ContentRoute path="/trove-next" permission={Permissions.PENDING_KYC} component={TroveNextPages} />
                <ContentRoute path="/corporate-accounts" permission={Permissions.PENDING_KYC} component={CorporateAccountsPages} />
                <ContentRoute path="/orders" permission={Permissions.ORDERS} component={OrderManagementPages} />
                <ContentRoute path="/transactions" permission={Permissions.TRANSACTIONS} component={TransactionManagement} />
                <ContentRoute path="/stalled-transaction" permission={Permissions.STALLED_TRANSACTIONS} component={StalledTransaction} />
                <ContentRoute path="/payments" permission={Permissions.PAYMENTS} component={PaymentManagement} />
                <ContentRoute path="/portfolio-creation" permission={Permissions.ACCOUNTS} component={PortfolioCreation} />
                <ContentRoute path="/users" permission={Permissions.PROFILE} component={UserManagementPages} />
                <ContentRoute path="/social" permission={Permissions.PROFILE} component={SocialManagement} />
                <ContentRoute path="/ai-workspace" permission={Permissions.SOCIAL} component={AiAssistant} />
                <ContentRoute path="/campaigns" permission={Permissions.CAMPAIGNS} component={CampaignManagementPages} />
                <ContentRoute path="/security-questions" permission={Permissions.SECURITY_QUESTIONS} component={SecurityQuestionPages} />
                <ContentRoute path="/maintenance" permission={Permissions.MAINTENANCE_FEE} component={MaintenanceFeeManagementPages} />
                <ContentRoute path="/instruments" permission={Permissions.INSTRUMENTS} component={Instruments} />
                <ContentRoute path="/themes" permission={Permissions.THEMES} component={ThemeManagementPages} />
                <ContentRoute path="/exchange-rates" permission={Permissions.EXCHANGE_RATES} component={ExchangeRateManagementPages} />
                <ContentRoute path="/holdings" permission={Permissions.HOLDINGS} component={HoldingManagement} />
                <ContentRoute path="/cards" permission={Permissions.CARDS} component={CardManagement} />
                <ContentRoute path="/subscriptions" permission={Permissions.SUBSCRIPTIONS} component={SubscriptionManagement} />
                <ContentRoute path="/commercial-papers" permission={Permissions.SUBSCRIPTIONS} component={CommercialPaperManagementPages} />
                <ContentRoute path="/reports" permission={Permissions.REPORTS} component={ReportManagement} />
                <ContentRoute path="/gems" permission={Permissions.GEMS} component={GemsPages} />
                <ContentRoute path="/gift-cards" permission={Permissions.GIFT_CARDS} component={GiftCardManagement} />

                <Redirect to="error/error-v1" />
            </Switch>
        </Suspense>
    );
}
